import React, { useRef, useState } from "react";
import TributacaoCard from "./TributacaoCard";

const setText = (value) => value || '—';

const CClassTribResult = ({ result }) => {
  const cClassTribData = result?.cclass_trib;
  const assessment = result?.status_busca;
  const ncmList = result?.cclass_trib?.["lista de anexo"] || [];

  const [isListExpanded, setIsListExpanded] = useState(false);
  const listContentRef = useRef(null);

  const sortedNcmList = [...ncmList].sort((a, b) => {
    const itemA = parseInt(a.item, 10);
    const itemB = parseInt(b.item, 10);
    return itemA - itemB;
  });

  return (
    <div className="w-full max-w-7xl mx-auto py-8 ">
      <section className="grid gap-8 lg:grid-cols-[25rem_1fr]">
        <div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 h-max sticky top-4">
            <h3 className="text-lg font-bold mb-4">NCMs relacionado com a pesquisa</h3>
            <div
              ref={listContentRef}
              className={`space-y-2 overflow-y-auto transition-all ${isListExpanded ? 'max-h-none' : 'max-h-[28rem]'} scroll`}
            >
              {sortedNcmList.map((item, index) => (
                <div
                  key={index}
                  className="w-full text-left flex flex-col gap-3 rounded-lg border p-3 border-gray-200 bg-gray-50"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-mono text-md font-medium text-gray-800">
                      {item?.ncm}
                    </span>
                    <div className="flex flex-row gap-2">
                      <span className="text-xs border-green-200 bg-green-100 text-green-800 px-2 py-0.5 rounded">
                        {item?.anexo}
                      </span>
                      <span className="text-xs border-blue-200 bg-blue-100 text-blue-800 px-2 py-0.5 rounded">
                        Item {item?.item}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span className="text-xs border-green-200 bg-green-100 text-green-800 px-2 py-0.5 rounded">
                      Redução: {item?.perc_reducao}
                    </span>
                  </div>
                  <h3 className="text-xs mt-1 text-gray-600">
                    {item?.titulo}
                  </h3>
                  <p className="text-xs mt-1 text-gray-600">
                    {item?.descricao_anexo}
                  </p>
                </div>
              ))}
            </div>
            {(ncmList.length > 5) && (
              <button
                onClick={() => setIsListExpanded(!isListExpanded)}
                className="w-full mt-3 text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                <i className={`fa-solid ${isListExpanded ? 'fa-chevron-up' : 'fa-chevron-down'} mr-1`}></i>
                {isListExpanded ? 'Ver menos' : `Ver todos (${ncmList.length})`}
              </button>
            )}
          </div>
        </div>
        <aside className="sticky">
          <TributacaoCard
            assessment={assessment}
            cClassTrib={cClassTribData}
            ncmLinks={null}
            listcClassTrib={[]}
            setcClassTrib={() => { }}
          />
        </aside>
      </section>
    </div>
  );
};

export default CClassTribResult;